const getCurrentPage = (questionSections: any, onFinish: any) => {
	const someQuestionSections = questionSections.map((section: any) =>
		section.questions?.some(
			(question: any) =>
				question.campaignQuestionAnswer?.questionAnswerId !== null,
		),
	)

	const indexOfFirstQuestionSection = someQuestionSections.findIndex(
		(some: boolean) => !some,
	)

	if (indexOfFirstQuestionSection === -1) {
		onFinish()
		return questionSections.length
	} else {
		return indexOfFirstQuestionSection
	}
}

export default getCurrentPage
